import React from "react";
import SavePaymentMethodForm from "../components/SavePaymentMethodForm";

export default function UpdateCard({ setOpenCardDialog }) {
  return <SavePaymentMethodForm setOpenCardDialog={setOpenCardDialog} />;
}
